import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Alert, AlertIcon } from '@chakra-ui/react';

import api from '../../../services/api';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../Inputs/Input';
import InputDate from '../../Inputs/InputDate';
import InputSelect from '../../Inputs/Selects/InputSelect';

import { Container, Content, Header, FormView } from './styles';

interface ModalPARAMS {
  id?: string;
  onClose: any;
  isVisible: boolean;
  setParadas: any;
}

const horarios: any[] = [];

const ModalPausaProgramada: React.FC<ModalPARAMS> = ({
  id = 'modalPausaProgramada',
  onClose = () => {},
  isVisible,
  setParadas,
}) => {
  const handleOutSideClick = useCallback(
		(e: any) => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  );
  const handleOnClose = useCallback(() => {
    setVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  }, [onClose]);

  const formRef = useRef<FormHandles>(null);

  const [visible, setVisible] = useState(isVisible);

  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    for (let i = 0; i < 24; i++) {
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:00`,
        label: `${i < 10 ? `0${i}` : i}:00`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:15`,
        label: `${i < 10 ? `0${i}` : i}:15`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:30`,
        label: `${i < 10 ? `0${i}` : i}:30`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:45`,
        label: `${i < 10 ? `0${i}` : i}:45`,
      });
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          title: Yup.string().required('campo obrigatório'),
          comeca_em: Yup.string().required('Campo obrigatório.'),
          comeca_as: Yup.string().required('Campo obrigatório.'),
          termina_em: Yup.string().required('Campo obrigatório.'),
          termina_as: Yup.string().required('Campo obrigatório.'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api
          .post('portal/pausa/store_delete', {
            id: 0,
            title: data.title,
            comeca_em: `${data.comeca_em} ${data.comeca_as}`,
            termina_em: `${data.termina_em} ${data.termina_as}`,
          })
          .then(response => {
            if (response.data.check.che === 'N') {
              setMessage(response.data.check.men);
              setMessageVisible(true);
              return;
            }

            setParadas(response.data.paradas);
            handleOnClose();
          });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }
      }
    },
    [setParadas, handleOnClose],
  );

  const inputDisabled = useCallback(() => {
    formRef.current?.getFieldValue('comeca_em') &&
      formRef.current?.getFieldValue('comeca_as') &&
      setIsDisabled(false);
  }, []);

  return (
    <Container id="modalPausaProgramada" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>Criar pausa programada</h1>
          <h2>
            A loja ficará indisponível nesta data, mesmo que esteja dentro do
          </h2>
          <h2>horário de funcionamento.</h2>
          <hr />
        </Header>

        <FormView ref={formRef} onSubmit={handleSubmit}>
          {messageVisible && (
            <Alert
              status="error"
              style={{
                marginTop: '10px',
                marginBottom: '10px',
                borderRadius: '10px',
              }}
            >
              <AlertIcon />
              {message}
            </Alert>
          )}

          <div className="input">
            <span>Título da pausa</span>
            <Input name="title" placeholder="Título da pausa"></Input>
          </div>

          <div className="inputs-date">
            <div className="input-inputs">
              <span>Começa em</span>

              <div className="inputs-view">
                <InputDate
                  name="comeca_em"
                  placeholder="comeca_em"
                  onChange={inputDisabled}
                />

                <InputSelect
                  name="comeca_as"
                  options={horarios}
                  placeholder="Começa as"
                  containerStyle={{ marginBottom: '6px' }}
                  defaultValue={''}
                  onChange={inputDisabled}
                />
              </div>
            </div>

            <div className="input-inputs">
              <span>Termina em</span>

              <div className="inputs-view">
                <InputDate
                  name="termina_em"
                  placeholder="termina_em"
                  disabled={isDisabled}
                />

                <InputSelect
                  name="termina_as"
                  options={horarios}
                  placeholder="Termina as"
                  containerStyle={{ marginBottom: '6px' }}
                  defaultValue={''}
                  disabled={isDisabled}
                />
              </div>
            </div>
          </div>

          <div className="buttons">
            <button className="save" type="submit">
              Salvar Pausa Programada
            </button>

            <button
              type="button"
              onClick={() => {
                setVisible(false);
                handleOnClose();
              }}
            >
              Cancelar
            </button>
          </div>
        </FormView>
      </Content>
    </Container>
  );
};

export default ModalPausaProgramada;
